import { render, staticRenderFns } from "./OurCredentials.vue?vue&type=template&id=26e94228&"
import script from "./OurCredentials.vue?vue&type=script&lang=js&"
export * from "./OurCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports